<template>
	<div style="background-color: #fff;width: 100%;">
		<div style="width: 750px;padding: 20px;">
			<div>
				<div style="font-size: 14px;">
					页眉代码此代码 <span style="color: #9d9d9d;margin-left: 10px;font-size: 12px;">{{tit}}</span>
				</div>
				<el-input style="margin-top: 10px;" type="textarea" :rows="7" placeholder="请输入内容" v-model="dataItem.headCode">
				</el-input>
			</div>
			<div style="margin-top: 10px;">
				<div style="font-size: 14px;">
					页眉代码此代码 <span style="color: #9d9d9d;margin-left: 10px;font-size: 12px;">{{tit1}}</span>
				</div>
				<el-input style="margin-top: 10px;" type="textarea" :rows="7" placeholder="请输入内容" v-model="dataItem.bodyTopCode">
				</el-input>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		props: {
			dataItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				tit:"将会出现在<head>标签部分",
				tit1:"此代码，将会出现在结束</body>标签上方"
			}
		},
		methods: {
			
		}
	}
</script>

<style>
</style>